import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
let ErpIndex = class ErpIndex extends Vue {
};
ErpIndex = __decorate([
    Component({
        name: 'erpIndex',
    })
], ErpIndex);
export default ErpIndex;
